import { Component, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Stat } from '@shared/index';
import dayjs from 'dayjs';
import { ApexAxisChartSeries, ApexXAxis, ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { AdminService } from '@shared-angular/services/admin.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-userstatistics-tab',
  imports: [NgApexchartsModule, ManualLinkComponent, MessageModule, ButtonModule, MenuModule],
  templateUrl: './userstatistics-tab.component.html'
})
export class UserstatisticsTabComponent {
  @ViewChildren('apexCharts') public apexCharts!: QueryList<ChartComponent>;
  public graphData = new Map<string, { series: ApexAxisChartSeries, xAxis: ApexXAxis }>();
  public dataByDay = new Map<string, Map<string, number>>;
  public graphs: string[] = [];

  constructor(private route: ActivatedRoute, private adminService: AdminService, private rsService: RouteShareService, private toastrService: ToastrService) {
    route.data.subscribe(data => {
      if (data['stats']) {
        const stats: Stat[] = data['stats'] as Stat[];
        stats.sort((stat1, stat2) => {
          if (stat1.created < stat2.created) {
            return -1;
          }

          if (stat1.created > stat2.created) {
            return 1;
          }

          return 0;
        });

        stats.forEach(stat => {
          if (!this.graphs.find(graph => graph == stat.name)) {
            this.graphs.push(stat.name);
            this.dataByDay.set(stat.name, new Map());
          }

          const day = dayjs(stat.created).format('YYYY-MM-DD');
          if (!this.dataByDay.get(stat.name)?.has(day)) {
            this.dataByDay.get(stat.name)?.set(day, 0);
          }

          const count = this.dataByDay.get(stat.name)?.get(day);
          this.dataByDay.get(stat.name)?.set(day, (count ?? 0) + 1);
        });

        this.graphs.forEach(graph => {
          const chartSeries: ApexAxisChartSeries = [{ name: graph, data: [] }];
          const xAxis: ApexXAxis = { categories: []/*, labels: { rotate: 90, offsetY: 90 } */ };
          this.dataByDay.get(graph)?.forEach((count, day) => {
            (chartSeries[0]?.data as number[]).push(count);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            xAxis.categories.push(day);
          });
          this.graphData.set(graph, { series: chartSeries, xAxis: xAxis });
        });
      }
    });
  }

  public exportToSVG(index: number) {
    this.apexCharts.toArray()[index]?.chartInstance().exports.exportToSVG();
  }

  public exportToPng(index: number) {
    this.apexCharts.toArray()[index]?.chartInstance().exports.exportToPng();
  }

  public exportToCSV(stat: string, index: number) {
    this.apexCharts.toArray()[index]?.chartInstance().exports.exportToCSV({ fileName: stat, series: this.graphData.get(stat)?.series });
  }

  public async deleteStat(stat: string) {
    const statIndex = this.graphs.findIndex(graph => graph == stat);
    if (statIndex > -1) {
      const deleted = await this.adminService.deleteUserStat(this.rsService.botConfig._id, stat);
      if (deleted.acknowledged && deleted.deletedCount > 0) {
        this.graphs.splice(statIndex, 1);
        this.dataByDay.delete(stat);
        this.graphData.delete(stat);
      } else {
        this.toastrService.error("GENERAL", $localize`:@@user-statistics-delerror:Der Stat konnte nicht gelöscht werden`);
      }
    }
  }

  public graphContextMenu: MenuItem[] = [];

  public openGraphMenu(event: Event, menu: Menu, graph: string, index: number) {
    this.graphContextMenu = this.buildGraphMenuItems(graph, index);
    menu.toggle(event);
  }

  private buildGraphMenuItems(graph: string, index: number): MenuItem[] {
    return [
      {
        label: $localize`:@@export-as-svg:Als SVG exportieren`,
        icon: 'ri ri-image-2-fill',
        command: () => { this.exportToSVG(index); }
      },
      {
        label: $localize`:@@export-as-png:Als PNG exportieren`,
        icon: 'ri ri-image-fill',
        command: () => { this.exportToPng(index); }
      },
      {
        label: $localize`:@@export-as-csv:Als CSV exportieren`,
        icon: 'ri ri-file-excel-fill',
        command: () => { this.exportToCSV(graph, index); }
      },
      {
        label: $localize`:@@delete-stat:Stat löschen`,
        icon: 'ri ri-close-large-fill',
        command: () => this.deleteStat(graph)
      }
    ];
  }
}